import { inject } from '@angular/core';
import { RedirectCommand, Router, type CanActivateFn } from '@angular/router';
import { AppRouting } from '@core/enums';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { combineLatest, map } from 'rxjs';

export const jottaGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  const isLimited$ = store.select(userFeature.selectIsMsisdnLimited);
  const isJottaInUse$ = store.select(userFeature.selectIsJottaInUse);

  return combineLatest([isLimited$, isJottaInUse$]).pipe(
    map(([isLimited, isJottaInUse]) =>
      isLimited && !isJottaInUse
        ? new RedirectCommand(router.parseUrl(`/${AppRouting.LimitedUser}`))
        : true
    )
  );
};
